/**
 * Chart color roles for report blocks — CSS var references so light/dark
 * resolve at render time. Hex values live in src/styles/report.css and are
 * VALIDATED (colorblind-safety + contrast); never bypass these tokens.
 */
export const REPORT_CATEGORICAL = [
  'var(--report-cat-1)',
  'var(--report-cat-2)',
  'var(--report-cat-3)',
  'var(--report-cat-4)',
  'var(--report-cat-5)',
] as const

export const REPORT_BURDEN = 'var(--report-burden)'
export const REPORT_CREDIT = 'var(--report-credit)'
export const REPORT_NEUTRAL = 'var(--report-neutral)'
